import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/images/logo.png";
import "../Style/Navber.scss";
const Navber = () => {
  const[cursorX,setCursorX] = useState()
  const[cursorY,setCursorY] = useState()
  const[navber,setNavber]= useState(false);

  window.addEventListener('mousemove',(e) =>{
    setCursorX(e.pageX)
    setCursorY(e.pageY)
  })
  
const changeBackground = () => {
  if(window.scrollY >= 80){
    setNavber(true);
} else {
  setNavber(false);
}
};

window.addEventListener('scroll',changeBackground);


  return (
    <div className={navber ?'navber active':'navber'}>
      <div className="navLeft">
        <img className="logo" src={logo} alt="" />
      </div>
      <div className="navCenter">
        <ul className="navList">
          <li className="navListItems">
            <Link className="link" to="/">
              Home
            </Link>
          </li>
          <li className="navListItems">
            <Link className="link" to="/service">
              Service
            </Link>
          </li>
          <li className="navListItems">
            <Link className="link" to="/about">
              About
            </Link>
          </li>
          <li className="navListItems">
            <Link className="link" to="/ourProjects">
              Our Projects
            </Link>
          </li>
          <li className="navListItems">
            <Link className="link" to="/contactUs">
              Contact Us
            </Link>
          </li>
          <li className="navListItems">
            <Link className="link" to="/blog">
              Blog
            </Link>
          </li>
          <div className='cursor'
      style={{left: cursorX + 'px',
              top: cursorY + 'px'
              }}
              >
      </div>
        </ul>
      </div>
      <div className="navRight">
        <div className="iconContainer">
          <div className="language">
            {" "}
            <div>
              Eng
              <HorizontalRuleIcon />
            </div>
          </div>
          <br />

          <div className="mailbox">
            <MailOutlineIcon />
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Navber;
